import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import SVG from "react-inlinesvg";

interface Props {
  text?: string;
  size?: string;
  children?: React.ReactNode;
  textStyle?: string;
  gap?: string;
}

function NoResultCustom({
  text = "결과가 없습니다.",
  size = "16px",
  children,
  textStyle = "body-md-regular",
  gap = "2px",
}: Props) {
  return (
    <Flex
      justifyContent={"center"}
      alignItems={"center"}
      width={"100%"}
      height={"100%"}
    >
      <Flex flexDirection={"column"} gap={gap} alignItems={"center"}>
        <Box color={"#D4D4D1"}>
          <SVG
            src={"/icons-v1_1/warning-triangle-solid.svg"}
            width={size}
            height={size}
          />
        </Box>
        <Text textStyle={textStyle} color={"#6F6F6C"}>
          {text}
        </Text>
        {children}
      </Flex>
    </Flex>
  );
}

export default NoResultCustom;
